import ApiWrapper from 'wrappers/api';

import {
  contactUsEmailRequestSent, contactUsEmailRequestSuccessful,
  getContactUsRecipientsRequestSent, getContactUsRecipientsRequestSuccessful,
  getAdminContactUsRecipientsRequestSent, getAdminContactUsRecipientsRequestSuccessful,
  createContactUsRecipientRequestSent, createContactUsRecipientRequestSuccessful,
  updateContactUsRecipientRequestSent, updateContactUsRecipientRequestSuccessful,
} from 'actions/atomic/contactUs';

export function getContactUsRecipients() {
  return (dispatch) => {
    dispatch(getContactUsRecipientsRequestSent());
    return ApiWrapper.get('/contact_us_recipients')
      .then(response => {
        dispatch(getContactUsRecipientsRequestSuccessful(response.data));
      });
  };
}

export function getAdminContactUsRecipients() {
  return (dispatch) => {
    dispatch(getAdminContactUsRecipientsRequestSent());
    return ApiWrapper.get('/contact_us_recipients/admin')
      .then(response => {
        dispatch(getAdminContactUsRecipientsRequestSuccessful(response.data));
      });
  };
}

export function createContactUsRecipient(contactUsRecipient) {
  return (dispatch) => {
    dispatch(createContactUsRecipientRequestSent());
    return ApiWrapper.post('/contact_us_recipients', contactUsRecipient)
      .then(response => {
        dispatch(createContactUsRecipientRequestSuccessful(response.data));
      });
  };
}

export function updateContactUsRecipient(contactUsRecipient) {
  return (dispatch) => {
    dispatch(updateContactUsRecipientRequestSent());
    return ApiWrapper.put(`/contact_us_recipients/${contactUsRecipient.id}`, contactUsRecipient)
      .then(response => {
        dispatch(updateContactUsRecipientRequestSuccessful(response.data));
      });
  };
}

export function sendContactUsEmail(email) {
  return (dispatch) => {
    dispatch(contactUsEmailRequestSent());
    return ApiWrapper.post('/contact_us', email)
      .then(response => {
        dispatch(contactUsEmailRequestSuccessful(response.data));
      });
  };
}
